import { createFileRoute, redirect } from '@tanstack/react-router';
import { SignUp } from '@/pages/sign-up';
import { PROTECTED, DASHBOARD, SIGN_IN } from '@/lib/constants/routes';
import { SELECTED_TENANT } from '@/lib/constants/tokens';
import Cookies from 'js-cookie';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';
import { isProductionEnv } from '@/lib/env';

export const Route = createFileRoute('/sign-up')({
  beforeLoad: async () => {
    // In produzione la registrazione self-service è disabilitata: i tenant
    // vengono creati tramite firma del contratto. La pagina non è accessibile.
    if (isProductionEnv) {
      throw redirect({ to: SIGN_IN });
    }

    const data = await ensureAuthData(queryClient);
    if (!data.authenticated) return;

    const selectedTenantCookie = Cookies.get(SELECTED_TENANT);
    if (selectedTenantCookie) {
      throw redirect({ to: `${PROTECTED}${DASHBOARD}` });
    }
  },
  component: SignUp,
});
